<template>
  <div
    v-if="properties"
    :class="['grid-editor string', properties.classes]"
    :style="properties.styles">
    <el-form :model="form"
             ref="form"
             @submit.native.prevent="$emit('submit')">
      <el-form-item
        prop="model"
        :rules="properties.required">
        <el-date-picker
          v-model="form.model"
          type="date"
          :placeholder="properties.placeholder"
          :size="properties.size"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          ref="field"
          @change="handlerChange"
          @blur="handlerBlur"
          @keyup.native.prevent.esc="$emit('cancel')"/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditorDate',
  props: {
    options: { type: Object },
    data: { type: Object, required: true },
    isEdit: { type: Boolean, default: false }
  },
  watch: {
    options: 'parserOptions',
    data: 'parserDate',
    isEdit: 'handleIsVisible'
  },
  data () {
    return {
      form: { model: '' },
      properties: null
    }
  },
  created () {
    this.parserOptions()
    this.parserDate()
  },
  methods: {
    OPTIONS () {
      return {
        // main
        field: '',
        value: '',
        required: null,
        // style
        placeholder: this.L10n('please-input-date'),
        classes: '',
        styles: '',
        size: '',
        customBehaviour: false
      }
    },
    // General Parser
    parserOptions () {
      this.properties = this.$_.merge(this.OPTIONS(), this.options)
      // set default validate rule if (required === true)
      if ([true, 'true'].includes(this.properties.required)) {
        this.properties.required = this.getValidationRule('required')
      }
      this.setFocus()
    },
    parserDate () {
      this.form.model = this.data[this.properties.field]
      this.setFocus()
    },
    setFocus () {
      this.$nextTick(() => {
        if (this.$refs.field) this.$refs.field.focus()
      })
    },
    // PUBLIC
    validate () {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) resolve(this.getValue())
        })
      })
    },
    getValue () {
      let result = {}
      result[this.properties.field] = this.form.model
      return result
    },
    // Handlers
    handlerBlur () {
      this.$emit('cancel')
    },
    handlerChange () {
      this.$emit('submit')
    }
  }
}
</script>

<style>

</style>
